module.exports = __webpack_public_path__ + "static/media/falsemirror-grid.c1ebbf05.jpg";